import { addMarkersToMap } from './markers/load';
import { assetURL } from '../url';

type MapImage = {
    name: string;
    url: URL;
}

const mapImages: Array<MapImage> = [
    {
        name: 'close-icon',
        url: assetURL( '/images/cancel-solid-grey.png' ),
    },
];

async function addAllImagesToMap( ctx: mapboxgl.Map ): Promise<void> {
    await addMarkersToMap( ctx );

    mapImages.forEach( ( img: MapImage ) => {
        ctx.loadImage( img.url.toString(), ( error: Error | undefined, image: HTMLImageElement ) => {
            if ( ctx.hasImage( img.name ) ) {
                ctx.removeImage( img.name );
            }

            if ( error ) {
                throw new Error( `Failed to load image "${img.url.toString()}", err: ${error.message}` );
            }

            ctx.addImage( img.name, image );
        } );
    } );
}

export {
    addAllImagesToMap,
};
